import React from 'react';

import { Box, Typography, useTheme } from '@mui/material';
import { useTranslation } from 'next-i18next';

import FontAwesomeIcon from '@components/atoms/fontAwesomeIcon';
import { BASE_URL } from '@helpers/constants';

const PolicyFooter = () => {
  const { t } = useTranslation('common');
  const theme = useTheme();

  return (
    <Box
      sx={{
        display: 'flex',
        width: '100%',
        backgroundColor: theme.palette.grey[100],
        py: { md: '19px', xs: '16px' },
        px: { md: 'auto', xs: '24px' },
        justifyContent: 'center',
        alignItems: 'center',
        textAlign: 'center',
        gap: '8px',
        flexDirection: {
          md: 'row',
          xs: 'column',
        },
      }}
    >
      <Typography variant="BaseLegacy" color={theme.palette.textV2.secondary}>
        SkillLane © {new Date().getFullYear()} SkillLane.com All rights reserved.{' '}
      </Typography>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          gap: '8px',
          textAlign: 'center',
          flexWrap: 'wrap',
        }}
      >
        <Typography
          variant="body2lanna"
          color={theme.palette.primaryV2.main}
          href={`${BASE_URL.IDENTITY_URL}/PrivacyPolicy`}
          target="_blank"
          component="a"
          fontFamily="Lanna"
        >
          {t('home.footer.policy')}
        </Typography>
        <FontAwesomeIcon width="3px" icon="fa-solid fa-circle" style={{ fontSize: '3px' }} />
        <Typography
          variant="body2lanna"
          color={theme.palette.primaryV2.main}
          href="/user_agreement"
          target="_blank"
          component="a"
          className="user-agreement link"
          fontFamily="Lanna"
        >
          {t('home.footer.user_agreement')}
        </Typography>
        <FontAwesomeIcon width="3px" icon="fa-solid fa-circle" style={{ fontSize: '3px' }} />
        <Typography
          variant="body2lanna"
          color={theme.palette.primaryV2.main}
          href="/privacy-notice"
          target="_blank"
          component="a"
          className="user-agreement link"
          fontFamily="Lanna"
        >
          {t('home.footer.privacy_notice')}
        </Typography>
      </Box>
    </Box>
  );
};

export default PolicyFooter;
